import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UserService } from '@kortobaa-front/authentication';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PlatformService } from '../../../core/services/platform.service';
import { NotificationService } from '../notification/notification.service';
// import { checkLanguagePipe } from "src/app/shared/pipes/checkLanguage.pipe";
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '../../../auth/services/auth.service';
import { NotifictionNumberPipe } from '../../../shared/pipes/notifiction-number.pipe';
// import { LanguageIconComponent } from "../../../shared/components/language-icon/language-icon.component";
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    // checkLanguagePipe,
    NotifictionNumberPipe,
    MatMenuModule,
    // LanguageIconComponent,
  ],
})
export class HeaderComponent {
  @Input() route: any = [];
  @Input() sideNavToggleBtn: boolean = false;
  navFlag: string = 'close';
  hasUnseenNotification!: number;
  @Output() sideNavToggleBtnRes = new EventEmitter<boolean>();
  userLogin!: any;
  notifySub$!: Subscription;
  currentRole!: string;

  constructor(
    private _notification: NotificationService,
    public user: UserService,
    public _platForm: PlatformService,
    public _translate: TranslateService,
    public auth: AuthService,
    private titleService: Title
  ) {
    this._notification.emitCloseDialog(this.navFlag);
    this._notification.getCloseDialog().subscribe((data) => {
      this.navFlag = data;
    });
    this.userLogin =
      !!this.auth.user.currentUser &&
      !!localStorage.getItem('Token') &&
      !!localStorage.getItem('UserProfile');
    this.currentRole = this.auth.getCurrentUser().roles[0];
  }

  async ngOnInit() {
    (await this.user.checkUserValid()).subscribe((data: any) => {
      if (data) {
        this._notification.getNotificationsCount().subscribe((data: any) => {
          this.hasUnseenNotification = data.count;
        });
      }
    });
    this._notification.getUserIsAuthenticated().subscribe((data: any) => {
      this._notification.getNotificationsCount().subscribe((data: any) => {
        this.hasUnseenNotification = data.count;
      });
    });
    this._notification.getSeenNotification().subscribe((data: any) => {
      this._notification.getNotificationsCount().subscribe((data: any) => {
        this.hasUnseenNotification = data.count;
      });
    });

    // Check notifications when tab (or browser window) regains focus
    let visibilityChangeHandler = () => {
      if (document.visibilityState === 'visible' && !!this.user.currentUser) {
        this._notification.getNotificationsCount().subscribe((data: any) => {
          this.hasUnseenNotification = data.count;
        });
      }
    };
    document.addEventListener('visibilitychange', visibilityChangeHandler);
    this.setTitleByRole();
  }

  setTitleByRole() {
    if (this.currentRole === 'superAdmin' || this.currentRole === 'admin') {
      this.titleService.setTitle('Nasij Alataa | Admin');
    } else if (this.currentRole === 'receivingDispatcherOfficer') {
      this.titleService.setTitle('Nasij Alataa | Dispatcher');
    } else {
      this.titleService.setTitle('Nasij Alataa | Supervisor');
    }
  }

  // open notification
  openNotification(value: any) {
    this.navFlag = this.navFlag == 'close' ? 'open' : 'close';
    this._notification.emitCloseDialog(this.navFlag);
    if (this.navFlag == 'open') {
      // this.notifySub$ = this._notification.updateNotificationToSeen().subscribe((data) => {
      //   // this.hasUnseenNotification = false;
      //   this._notification.emitSeenNotification();
      // });
      this._notification.emitOpenDialog();
    }
  }

  ngOnDestroy(): void {
    if (this.notifySub$) this.notifySub$.unsubscribe();
  }
}
